import { BaseConverter, baseConvertStatic } from '../base-converter';
import parser from '../parser/node';

export const convertStatic = htmlString => baseConvertStatic(htmlString, parser);
export default () => BaseConverter(parser);
